import { useEffect } from "react";
import PageContainer from "./components/PageContainer";

function App() {
  useEffect(() => {
    window.onbeforeunload = function () {
      window.scrollTo(0, 0);
    };
  });

  return (
    <div className="App text-slate-200">
      <PageContainer />
    </div>
  );
}

export default App;
